import axios from 'axios';
import { message as AntMsg } from 'antd';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: import.meta.env.VITE_API_TIMEOUT,
  headers: { adm: 1 },
});

export const getToken = () => {
  return localStorage.getItem('accessToken');
};

export const setToken = (token) => {
  localStorage.setItem('accessToken', token);
};

export const clearToken = () => {
  localStorage.removeItem('accessToken');
};

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const { data, code, message } = response.data;

    console.log(
      `✅ ${response.config.url} ${response.config.method?.toUpperCase()}`,
      data
    );

    if (code === -1) {
      AntMsg.error(message);
      // 可以在这里添加全局错误提示，比如 toast
      return Promise.reject(new Error(message || '请求失败'));
    }

    return data;
  },
  (error) => {
    // 处理401 - 权限过期
    if (error.response?.status === 401) {
      AntMsg.error('账号权限已过期，请重新登录');
      clearToken();
      // 重定向到登录页
      window.location.href = '/login';
      return Promise.reject(new Error('账号权限已过期'));
    }

    // 处理网络错误或其他异常
    const message =
      error.response?.data?.message || error.message || '网络错误';
    return Promise.reject(new Error(message));
  }
);

export default instance;
